export const formatBlogDate = (date, locale) =>
  date
    ? new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(date))
    : '';
